import * as actionTypes from './actionTypes'

export function triggerPSC(){
  return {
    type: "TRIGGER_PSC"
  }
}

export function unTriggerPSC(){
  return {
    type: "UN_TRIGGER_PSC"
  }
}

export function saveHeaderReason(tabName, headerReason) {
    return {
      type: actionTypes.SAVE_HEADER_REASON,
      tabName,
      headerReason
    }
  }
  
  export function saveLineReason(merchandiseId, lineReason, lineItemIndex) {
    return {
      type: actionTypes.SAVE_LINE_REASON,
      merchandiseId,
      lineReason,
      lineItemIndex
    }
  }

  export function updatePscData(payload){
    return {
      type: actionTypes.UPDATE_PSC_DATA,
      payload
    }
  }

  export function savePscData(payload){
    return {
      type: actionTypes.SAVE_PSC_DATA,
      payload
    }
  }
  
